angular.module('bbl.module.dashboard.filters', [])
.filter('callers', function() {
	var filter = function(prop, expect, caller) {
		return !expect || caller[prop];
	};

	var idString = function(array) {
		return array.reduce(function(str, el) {
			return str+(el.id||JSON.stringify(el));
		}, '');
	};

  var ts = {};
	var cached = {};

	return function(callers, filters) {
		var nameFilter = (filters.name||'').toString().toLowerCase();

		if(!Array.isArray(callers)) {
			callers = [];
		}

		var filtered = callers.filter(function(caller) {
			return caller.name.toLowerCase().indexOf(nameFilter) > -1 ||
				caller.source.toLowerCase().indexOf(nameFilter) > -1;
		})
		.filter(function(caller) {
			if(!(filters.is_deafened || filters.is_muted || filters.is_unmuted || filters.has_hand_raised)) {
				return true;
			}

			return (
				(filters.is_deafened && caller.is_deafened) ||
        (filters.is_muted && caller.is_muted) ||
				(filters.is_unmuted && !caller.is_muted) ||
				(filters.has_hand_raised && caller.has_hand_raised)
			);
		});

    // "stabilize" output
    var idstr = idString(filtered);
		if(cached[idstr] && Date.now() - ts[idstr] < 100) {
			return cached[idstr];
		}

    ts[idstr] = Date.now();
		return (cached[idstr] = filtered);
	};
})
.filter('countKeys', function() {
	return function(obj) {
		return Object.keys(obj||{}).length;
	};
})
.filter('confirmAction', ['$window', function($window) {
	return function(cb, message) {
		if($window.confirm(message || 'Are you sure?')) {
			(cb||angular.noop).call();
		}
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard.filters.js
 ** module id = 324
 ** module chunks = 0
 **/